<!-- template v.1 -->
<template>
<div class="col py-3">

            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Gestión de Empleados </h4>
    
            </div>
  
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtros</h3>
                
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                      <div class="col-md-4 form-org">
                        <div class="form-group ">
                          <label class="col-form-label" >
                            Local</label
                          >
                          <select class="form-control"    v-model="Local" @click="CargaReloj()">
                            <option value="-1" >Todos </option>
                            <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                            
                          </select>
                        </div>

                        <div class="form-group">
                          <label class="col-form-label" style="width: 100%;">
                          DNI
                          </label>
                          <input type="number"
                          class="form-control"
                          @keypress="MaxNumber($event)"
                          pattern="^[0-9]+"
                          oninput="validity.valid||(value='');"
                          v-model="DNI"
                          placeholder="XXXXXXXXX" 
                          onwheel="this.blur()"
                          step="1-9"
                          min="0"
                          max="99999999"
                          autocomplete="off">
                        </div>
                      </div>
                      <div class="col-md-4 form-org">
                        <div class="form-group">
                          <label class="col-form-label" >
                            Área</label
                          >
                          <select class="form-control"   v-model="Area">
                            <option value="-1">Todos </option>
                            <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                            
                          </select>
                        </div>
                        <div class="form-group mb-3">
                            <label class="col-form-label"  style="width: 100%;">
                            Nombres
                            </label>
                            <input type="text" class="form-control" v-model="Nombres" placeholder="Nombres" maxlength="50">
                            
                        </div>
                      </div>
                      <div class="col-md-4 form-org">
                        <div class="form-group">
                          <label class="col-form-label" >
                            Estado</label
                          >
                          <select class="form-control"  v-model="Estado">
                            <option value="-1"  >Todos </option>
                            <option v-for="item in Parametros" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                            
                          </select>
                        </div>

                        <div class="form-group mb-3">

                        </div>
                        
                        
                        
                      </div>
                  </div>

                </div>
             
               
               
                <div class="row">

                  <div class="col-md-4 form-org">
                    <div class="input-group">
                      <button type="submit" 
                      class="btn btn-success" 
                      style="width:100%" 
                      @click="Buscar()" >
                      
                      Buscar</button>
                    </div>
                  </div>

                  <div class="col-md-4 form-org">
                    <div class="input-group">
                      <button type="submit" 
                      class="btn btn-info" 
                      style="width:100%" 
                      @click="Nuevo()" >
                      
                      Nuevo</button>
                    </div>
                  </div>
                  

                </div>
              </div>
              <!-- /.card-body -->
            </div>
           
          

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;margin-bottom: 60px;">
          
          
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Código</th>
                      <th >DNI</th>
                      <th >Nombre Completo</th>
                      <th >Área</th>
                      <th >Local</th>
                      <th >Estado</th>
                      <th >Opción</th>
                   
                     
                    </tr>
                  </thead>
                  
                  <!-- <tbody v-for="(item, index) in ListaEmpleados.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index"> -->
                     <tbody v-for="(item, index) in ListaEmpleados"   v-bind:key="item" v-bind:index="index" >
                    <!--  <tr v-if="!item.disabled"> -->
                      <tr >
                      <td >{{item.nCodigo}}</td>
                      <td >{{item.sDni}}</td>
                      <td >{{item.sNombre}}</td>
                      <td >{{item.sArea}}</td>
                      <td >{{item.sLocal}}</td>
                      <td >{{item.sEstadoDesc}}</td>
                      <td ><button type="button" class="btn btn-info btn-table" @click="ModalEditarEmpleado(item)">Editar</button></td>


                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
                <!--<nav aria-label="Page navigation" class="text-center;">
                  <ul class="pagination pagination-sm " style="margin-bottom: 0px;float:right">
                    <li class="page-item">
                      <a href="#" aria-label="Previous" class="page-link" v-show="pag != 1" @click.prevent="pag -= 1">
                        <span aria-hidden="true">Anterior</span>
                      </a>
                    </li>
                    <li class="page-item" style="margin-right:0">
                      <a href="#" aria-label="Next" class="page-link" v-show="pag * NUM_RESULTS / Empleados.filter(Paginador).length < 1" @click.prevent="pag += 1">
                        <span aria-hidden="true">Siguiente</span>
                      </a>
                    </li>
                  </ul>
                </nav>
                -->
        </div>
</div>    

<ModalPeque v-show="ModalPeque.isNuevoEmpleado" :modalpeque="ModalPeque">  
    <div class="col-md-12" style="float: left;">
        <div class="row form-org">
          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Código SAP: </label>
            <input  type="number" 
                    class="form-control form-control-modal"
                    @keypress="MaxNumberCodSap($event)"  
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    v-model="codigoSap"
                    onwheel="this.blur()"
                    step="1-9"
                    min="0"
                    max="99999999"
                    autocomplete="off"
            >
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Nombre: </label>
            <input type="text" class="form-control form-control-modal" maxlength="50"  v-model="NombreModal">
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> DNI: </label>
            <input type="text" class="form-control form-control-modal"
              @keypress="MaxNumber($event)"
              v-model="DniModal"
              maxlength="8"
              autocomplete="off"
            >
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Genero:</label>
              <select class="form-control form-control-modal"  v-model="GeneroModal"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Generos" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                
              </select>
          </div>

          <div class="col-md-12 form-group mb-2" style="float: left">

              <label class="col-form-label label-modal">Fecha Nacimiento:</label>
                  <input type="date" v-model="FechaNacimiento" min="1990-01-01" max="2999-12-31" class="form-control form-control-modal" >  
          </div>

          <div class="col-md-12 form-group mb-2" style="float: left">

              <label class="col-form-label label-modal">Fecha Ingreso:</label>
                  <input type="date" v-model="FechaIngreso" min="1990-01-01" max="2999-12-31" class="form-control form-control-modal" >  
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Área: </label>
              <select class="form-control form-control-modal"  v-model="AreaModal"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Local: </label>
              <select class="form-control form-control-modal"  v-model="LocalModal"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Tipo HE: </label>
              <select class="form-control form-control-modal"  v-model="TipoHE">
                <option value="-1" >Seleccione </option>
                <option v-for="item in TiposHE" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Correo: </label>
            <input type="email" id="correo" class="form-control form-control-modal" maxlength="150" v-model="Correo">
          </div>

          <div class="col-md-12 form-group">
            <div class="modal-footer botones-modal">
              <button type="button" class="btn btn-success guardar-modal" @click="NuevoEmpleado()" >Guardar</button>
              <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isNuevoEmpleado = false"> Cancelar</button>
            </div>
          
          </div>
        </div>
     
        
       
    </div>    
</ModalPeque>

<ModalPeque v-if="displayEditarEmpleado" v-show="ModalPeque.isEditarEmpleado" :modalpeque="ModalPeque">  
    <div class="col-md-12" style="float: left;">
        <div class="row form-org">
          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Código SAP: </label>
            <input  type="number" disabled 
                    class="form-control form-control-modal"  
                    v-model="codigoSapEdit"
                    @keypress="MaxNumberCodSap($event)"  
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    onwheel="this.blur()"
                    step="1-9"
                    min="0"
                    max="99999999"
                    autocomplete="off"
            >
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Nombre: </label>
            <input type="text" class="form-control form-control-modal" maxlength="50"  v-model="NombreModalEdit">
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> DNI: </label>
            <input type="text" class="form-control form-control-modal"
              @keypress="MaxNumber($event)"
              v-model="DniModalEdit"
              maxlength="8"
              autocomplete="off"
            >
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Genero:</label>
              <select class="form-control form-control-modal"  v-model="GeneroModalEdit"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Generos" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                
              </select>
          </div>

          <div class="col-md-12 form-group mb-2" style="float: left">

              <label class="col-form-label label-modal">Fecha Nacimiento:</label>
                  <input type="date" v-model="FechaNacimientoEdit" min="1990-01-01" max="2999-12-31" class="form-control form-control-modal" >  
          </div>

          <div class="col-md-12 form-group mb-2" style="float: left">

              <label class="col-form-label label-modal">Fecha Ingreso:</label>
                  <input type="date" v-model="FechaIngresoEdit" min="1990-01-01" max="2999-12-31" class="form-control form-control-modal" >  
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Área: </label>
              <select class="form-control form-control-modal"  v-model="AreaModalEdit"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Local: </label>
              <select class="form-control form-control-modal"  v-model="LocalModalEdit"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Tipo HE: </label>
              <select class="form-control form-control-modal"  v-model="TipoHEEdit">
                <option value="-1" >Seleccione </option>
                <option v-for="item in TiposHE" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Correo: </label>
            <input type="text" class="form-control form-control-modal" maxlength="150"  v-model="CorreoEdit">
          </div>

          <div class="col-md-12 form-group mb-2">
            <label class="col-form-label label-modal"> Estado: </label>
              <select class="form-control form-control-modal"  v-model="EstadoModalEdit"  >
                <option value="-1" >Seleccione </option>
                <option v-for="item in Parametros" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
          </div>

          <div class="col-md-12 form-group">
            <div class="modal-footer botones-modal">
              <button type="button" class="btn btn-success guardar-modal" @click="EditarEmpleado()" >Guardar</button>
              <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEditarEmpleado = false"> Cancelar</button>
            </div>
          
          </div>
        </div>
     
        
       
    </div>   
</ModalPeque>

<div class="overlay-wrapper"  v-if="load">
    <div class="overlay" style="flex-direction: column;">
        <i class="spinner-border"></i>
        <div class="text-bold pt-2">Cargando...</div>
    </div>
</div>


</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      load: false,
      Generos: [],
      Locales:[],
      Areas:[],
      TiposHE:[],
      Relojes:[],
      Parametros:[],
      Genero: -1,
      GeneroModal: -1,
      LocalModal:-1,
      Area:-1,
      TipoHE: -1,
      AreaModal: -1,
      Local: -1,
      Reloj:-1,
      Estado:-1,
      alertax:false,
      codigoSap: '',
      FechaNacimiento: '',
      FechaIngreso: '',
      DNI:'',
      DniModal: '',
      Nombres:'',
      NombreModal: '',
      Correo: '',
      Empleados:[],
      ListaEmpleados:[],
      itemsPageDefault : 10,
      resultCount: 0,
      currentPage: 0,
      ModalPeque : {
       isNuevoEmpleado: false,
       isEditarEmpleado: false
      },
      codigoSapEdit: '',
      NombreModalEdit: '',
      DniModalEdit: '',
      GeneroModalEdit: -1,
      FechaNacimientoEdit: '',
      FechaIngresoEdit: '',
      AreaModalEdit: -1,
      LocalModalEdit: -1,
      TipoHEEdit: -1,
      CorreoEdit: '',
      EstadoModalEdit: -1,
      EmpleadoEspecifico: [],
      displayEditarEmpleado: false,
      emailRegex : '',

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        }
  },
  async mounted(){

    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    //Genero
    await this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=4", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          //console.log(response);
          this.Generos = response.data.oListaParametros;
        })
    //Local
    await this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })
    //Area
    await this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })
    //Tipo HE
    await this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=12", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          //console.log(response)
          this.TiposHE = response.data.oListaParametros;
        })

    await this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Parametros = response.data.oListaParametros;

        })
    this.displayEditarEmpleado = true;
  },
  methods: {
    Marcaciones(item){
      this.$router.push({name: 'marcaciones-empleados', query: {id: item.nCodigo, nombre :item.sNombre}});
    },
    NuevoEmpleado(){
      //console.log("Agregando...");
      //console.log(this.codigoSap);
      var codigoSap = this.codigoSap;
      var nombre = this.NombreModal;
      var dni = this.DniModal;
      var genero = this.GeneroModal;
      var fechaNac = this.FechaNacimiento;
      var fechaIng = this.FechaIngreso;
      var area = this.AreaModal;
      var local = this.LocalModal;
      var tipoHE = this.TipoHE;
      var correo = this.Correo;
      //console.log(dni);

      var sTrama = codigoSap + "|" + nombre + "|" + dni + "|" + genero + "|" + fechaNac + "|" +fechaIng + "|" +
                  area + "|" + local + "|" + tipoHE + "|" + correo;
      
      //console.log(sTrama);

      if(codigoSap == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Código SAP',
              icon: 'error',
              
              }); 
        return;
      }

      if(nombre == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Nombres',
              icon: 'error',
              
              }); 
        return;
      }

      if(dni == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar DNI',
              icon: 'error',
              
              }); 
        return;
      }
      

      if(genero == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Genero',
            icon: 'error',
            
            }); 
      return;
      }

      if(fechaNac == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Fecha Nacimiento',
              icon: 'error',
              
              }); 
        return;
      }

      if(fechaIng == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Fecha Ingreso',
              icon: 'error',
              
              }); 
        return;
      }

      if(area == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Área',
            icon: 'error',
            
            }); 
      return;
      }

      if(local == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Local',
            icon: 'error',
            
            }); 
      return;
      }

      if(tipoHE == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Tipo HE',
            icon: 'error',
            
            }); 
      return;
      }
      
      if(correo == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Correo',
              icon: 'error',
              
              }); 
        return;
      }

      this.emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

      if (this.emailRegex.test(correo)){
        //console.log("correcto");
      }else{
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Correo No Valido!',
              icon: 'error',
              
        }); 
        return;
      }





      
    

    let gestion = this.$store.state.menu;
    var bodyFormData = new FormData();
    bodyFormData.append("sTrama", sTrama);

    this.axios.post(gestion + "/Empleados/ManualNuevo", bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        }
        })
        .then((response) => {
        const data_res = response.data.satisfactorio;
        //this.load=false;
        if (data_res == true) { 

          this.ModalPeque.isNuevoEmpleado=false;

          this.codigoSap = "";
          this.NombreModal = "";
          this.DniModal = "";
          this.GeneroModal = -1;
          this.FechaNacimiento = "";
          this.FechaIngreso = "";
          this.AreaModal = -1;
          this.LocalModal = -1;
          this.TipoHE = -1;
          this.Correo = "";
          
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'success',
            
          });

          this.Buscar();
        }
        else {
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'error',
            
          });  
        }
         
      });
      


    },


    ModalEditarEmpleado(item){
        //console.log(item);
        this.load=true;
        var codigoEmpleado = item.nCodigo;
        //console.log(codigoEmpleado);

        let gestion = this.$store.state.menu;

        this.axios
        .get(gestion + "/Empleados/Obtener?nCodigo="+codigoEmpleado,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          console.log(response);
          this.EmpleadoEspecifico = response.data.oEmpleado;

            var fechaNac= this.EmpleadoEspecifico.sFecNac.split('/');
            var fechaIng = this.EmpleadoEspecifico.sFecIng.split('/');

            var formatFechaNac = fechaNac[2] + '-' + fechaNac[1] + '-'  + fechaNac[0];
            //console.log(formatFechaNac);
            
            var formatFechaIng = fechaIng[2] + '-' + fechaIng[1] + '-'  + fechaIng[0];

            

            this.codigoSapEdit = codigoEmpleado;
            this.NombreModalEdit = this.EmpleadoEspecifico.sNombre;
            this.DniModalEdit = this.EmpleadoEspecifico.sDni;
            this.GeneroModalEdit = this.EmpleadoEspecifico.nGenero;

            this.FechaNacimientoEdit = formatFechaNac;
            this.FechaIngresoEdit = formatFechaIng;

            this.AreaModalEdit = this.EmpleadoEspecifico.nArea;
            this.LocalModalEdit = this.EmpleadoEspecifico.nLocal;
            this.TipoHEEdit = this.EmpleadoEspecifico.nTipoHE;
            this.CorreoEdit = this.EmpleadoEspecifico.sCorreo;
            this.EstadoModalEdit = this.EmpleadoEspecifico.nEstado;

          const data_res = response.data.oResult.satisfactorio;

          

          if(data_res == true) {
            this.load=false;

            this.ModalPeque.isEditarEmpleado=true;
            this.ModalPeque.titulo = 'Editar Empleado';

            

            
          }
         

      
          
        })


    },

    EditarEmpleado(){
      //console.log("EDITANDO....");

      var sTrama = this.codigoSapEdit + "|" + this.NombreModalEdit + "|" + this.DniModalEdit + "|" 
                  +this.GeneroModalEdit + "|" + this.FechaNacimientoEdit + "|" +this.FechaIngresoEdit + "|" 
                  +this.AreaModalEdit + "|" + this.LocalModalEdit + "|" + this.TipoHEEdit + "|" + this.CorreoEdit + "|" 
                  +this.EstadoModalEdit;

      //console.log(sTrama);
      if(this.codigoSapEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Código SAP',
              icon: 'error',
              
              }); 
        return;
      }

      if(this.NombreModalEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Nombres',
              icon: 'error',
              
              }); 
        return;
      }

      if(this.DniModalEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar DNI',
              icon: 'error',
              
              }); 
        return;
      }


      if(this.GeneroModalEdit == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Genero',
            icon: 'error',
            
            }); 
      return;
      }

      if(this.FechaNacimientoEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Fecha Nacimiento',
              icon: 'error',
              
              }); 
        return;
      }

      if(this.FechaIngresoEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Fecha Ingreso',
              icon: 'error',
              
              }); 
        return;
      }

      if(this.AreaModalEdit == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Área',
            icon: 'error',
            
            }); 
      return;
      }

      if(this.LocalModalEdit == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Local',
            icon: 'error',
            
            }); 
      return;
      }

      if(this.TipoHEEdit == -1){
      this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe Seleccionar Tipo HE',
            icon: 'error',
            
            }); 
      return;
      }

      if(this.CorreoEdit == ""){
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Debe Ingresar Correo',
              icon: 'error',
              
              }); 
        return;
      }

      this.emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

      if (this.emailRegex.test(this.CorreoEdit)){
        //console.log("correcto");
      }else{
        this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: 'Correo No Valido!',
              icon: 'error',
              
        }); 
        return;
      }

    let gestion = this.$store.state.menu;
    var bodyFormData = new FormData();
    bodyFormData.append("sTrama", sTrama);

    this.axios.post(gestion + "/Empleados/ManualEditar", bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        }
        })
        .then((response) => {
        //console.log(response);
        const data_res = response.data.satisfactorio;
        //this.load=false;
        if (data_res == true) { 

          this.ModalPeque.isEditarEmpleado=false;
          
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'success',
            
          });

          this.Buscar();


        }
        else {
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'error',
            
          });  
        }
         
      });

      
    },

    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Su DNI debe contar con 8 dígitos',
            icon: 'error',
          
          });
            evt.preventDefault();
          }
    },

    MaxNumberCodSap : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Su código SAP debe contar máximo con 8 dígitos',
            icon: 'error',
          
          });
            evt.preventDefault();
          }
    },
        
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/Empleados/Listar?nLocal="+this.Local+
                        "&nArea="+this.Area+
                        "&nEstado="+this.Estado+
                        "&sNombre="+this.Nombres+
                        "&sDni="+this.DNI, 
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Empleados = response.data.oListaEmpleados;
          const countUser = this.Empleados.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
          }
          var index = this.currentPage * this.itemsPageDefault;      
          this.ListaEmpleados = this.Empleados.slice(index,index+this.itemsPageDefault);

          
        })

    
    },
     setPage: function(pageNumber) {
            this.currentPage = pageNumber;
 
        
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
                
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.ListaEmpleados = this.Empleados.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
        },
    CargaReloj(){
    const Reloj = this.Local;
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarRelojes?nCodigo="+ Reloj, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Relojes = response.data.oListaRelojes;
        })
    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Su DNI debe contar con 8 dígitos',
          icon: 'error',
          
          });
            evt.preventDefault();
          }
    },
    Nuevo(){
      //console.log("Registrando...")
      this.ModalPeque.isNuevoEmpleado=true;
      this.ModalPeque.titulo = 'Nuevo Empleado';
    }
    
   
        

  },
}
</script>

<style scoped>
  .btn-info{
    color: #fff !important;
  }

  .label-modal{
    float: left;
    font-size: 12px;
    font-weight: 500;
  }
  
  .form-control-modal{
    width: 60%;
    float:right;
    font-size: 0.8rem;
  }
</style>
